"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppTable = void 0;
var AppTable_1 = require("./AppTable");
Object.defineProperty(exports, "AppTable", { enumerable: true, get: function () { return AppTable_1.Table; } });
